import {EAutopaymentError} from '../BalanceReplenishment';
import {EApproveStatus} from '../MessageMatchers/definitions';
import {EActionNews} from './ActionNews/definitions';
import {ESpecialOffer} from './SpecialOffers/definitions';
import {
  EAutopaymentNotificationStatus,
  EPayKeeperNotificationStatus,
  ESystemNewsType,
  ESystemNotificationType,
  EWebNotificationType,
} from './model';

export default {
  button: {
    downloadErrorFile: 'Download error file',
    toAudienceSection: 'To the audience section',
    contactTechnicalSupport: 'Contact technical support',
    toReportBroadcast: 'To the broadcast report',
    toChannel: 'To the channel',
  },
  actionRequired: 'Action required',
  hideActionTitle: 'Hide this notification permanently?',
  hideActionSubtitle:
    'You will no longer see this notification and the link to the instructions here, but the information will remain available in the documentation',
  actionNews: {
    [EActionNews.FILL_DETAILS_REMINDER]: {
      title: 'Fill in company details',
      description:
        'You cannot register the channel until you fill in the details of your company and payment organizations',
      fill: 'Fill in company details',
      modalTitle: 'Company details',
    },
    [EActionNews.ACCEPT_TARIFFS_REMINDER]: {
      title: 'Accept your pricing',
      descriptionContract:
        'Familiarize yourself with the pricing and click "Fine!". Once the pricing is accepted, the channels are available for registration',
      descriptionDefault:
        'Familiarize yourself with the pricing and click "Accept". The pricing becomes active once accepted.',
      check: 'Check the pricing',
    },
    [EActionNews.ACCEPT_MM_API_REMINDER]: {
      title: 'Accept the Marketing Messages API (MM API) Terms of Use',
      description:
        'You haven’t accepted the Marketing Messages API (MM API) Terms of Use yet. Your WhatsApp campaigns are currently sent only via Cloud API, where messages are more expensive.',
      acceptApi: 'Accept the MM API terms to:',
      acceptReasons: [
        'send messages more efficiently',
        'increase the conversion of your campaigns',
      ],
      more: 'Learn more about MM API',
      accept: 'Accept the terms on Facebook',
    },
    [EActionNews.MAX_BOT_CONNECTION_PROMO]: {
      title: 'Connect <0></0>',
      description:
        'Grow your audience now and reach customers through the most reliable channel — 85M+ users are already there.\n' +
        'We’ll take care of your business registration. Get started in just a few clicks.',
      button: 'Connect MAX',
    },
    [EActionNews.DIALOGS_PROMO]: {
      title: 'Dialogs',
      description:
        'Keep all your communication with recipients in one place: broadcasts, chatbots, API messages, outgoing messages, and replies',
      button: 'Go to Dialogs',
    },
  },
  news: {
    [ESystemNewsType.UpdatePlanned]: {
      title: '{{date}} Update',
      content:
        "edna Pulse will be updated on <0></0>. We recommend that you don't schedule or send broadcasts between {{startTime}} and {{endTime}} due to short software interruptions.\n" +
        'We try to be the best for you! We hope you enjoy this update.',
    },
    [ESystemNewsType.WhatsAppLicensePriceUpdatePlanned]: {
      title: '[en] Изменение стоимости лицензии WhatsApp',
      content:
        '[en] С <0>1 апреля</0> повышается стоимость вашей лицензии WhatsApp Business API. С новой стоимостью вы можете ознакомиться в разделе <1>Профиль -> Профиль Компании -> Тарифы</1>. Учитывайте это при оплате лицензии за апрель, чтобы продолжать пользоваться сервисом.' +
        '<br/><br/>Мы не повышали цены на WhatsApp Business API почти 2 года, но больше не можем бороться с возросшими затратами. В связи со значительным ростом расходов на закупку нового инфраструктурного оборудования, поддержку текущего оборудования, оплату высококвалифицированных ИТ-специалистов и существующей инфляцией на другие компоненты нашей работы, мы вынуждены поднять стоимость лицензии. Кроме этого в edna Pulse были проведены глобальные доработки, которые позволят работать с сервисом ещё лучше.' +
        '<br/>При возникновении вопросов обратитесь к вашему менеджеру edna.',
    },
    [ESystemNewsType.MessageMatcherPresetSuggestion]: {
      title_one: 'Channel registered',
      title_other: 'Channels registered',
      content_one:
        "<0>Your channel {{channels}}</0> has been registered on Facebook! Let's choose templates for it!",
      content_other:
        "<0>Your channels {{channels}}</0> have been registered on Facebook! Let's choose templates for them!",
      action: 'Choose templates',
    },
  },
  system: {
    [ESystemNotificationType.UpdateRunning]:
      '{{date}} from {{startTime}} to {{endTime}} <0>edna Pulse update</0>. During this time, short software interruptions may occur.',
    [ESystemNotificationType.MaintenanceRunning]:
      'There are short software interruptions in edna Pulse. We are already working on fixing them!',
    [ESystemNotificationType.TemporaryProblem]:
      'When sending WhatsApp messages with attachments via API, a media-download-error may occur. It happens when WhatsApp cannot download the attachment from your server. We are working with WhatsApp to resolve the issue.',
  },
  toUploads: 'To downloads',
  toNotifications: 'To notifications',
  web: {
    [EWebNotificationType.SubscribersUploadFailed]: `The audience list has not been loaded.`,
    [EWebNotificationType.SubscribersUploadPartial]: `The audience list has not been fully loaded.`,
    [EWebNotificationType.SubscribersUploadSuccess]: `The audience list has been loaded.`,
    [EWebNotificationType.BroadcastCompleted]: `The broadcast "{{name}}" is completed.`,
    [EWebNotificationType.BroadcastCancelled]: `The broadcast "{{name}}" has been stopped.`,
    [EWebNotificationType.LicenseExpiring]:
      'Your edna Pulse license expires on {{date}}. To extend it, pay for the services.',
    [EWebNotificationType.CallbackUpdated]: `The webhook URL has been updated successfully.`,
    [EWebNotificationType.ApikeyUserUpdated]: `The API key has been updated successfully.`,
    [EWebNotificationType.CompanyDetailsUpdated]: `User "{{login}}" has changed the company details.`,
    [EWebNotificationType.PaymentDetailsUpdated]: `User "{{login}}" has changed the company payment details.`,
    [EWebNotificationType.TenantTariffAccepted]: `User "{{login}}" has agreed to the available pricing options.`,
    [EWebNotificationType.JivoEnabled]:
      'User {{login}} has connected all the WhatsApp channel traffic to the Jivo chat platform.',
    [EWebNotificationType.JivoDisabled]:
      'User {{login}} has disconnected all the WhatsApp channel traffic to the Jivo chat platform.',
    [EWebNotificationType.MessageMatcherStatusChanged]: {
      [EApproveStatus.DISABLED]:
        'Template "{{name}}" was disabled. All scheduled broadcasts using this template are stopped',
      [EApproveStatus.PAUSED]:
        'Template "{{name}}" was paused. All scheduled broadcasts using this template are stopped.',
      [EApproveStatus.APPROVED]: 'Template "{{name}}" status changed. New status: Active.',
      [EApproveStatus.REJECTED]: 'Template "{{name}}" status changed. New status: Rejected.',
      [EApproveStatus.PENDING]:
        'Template "{{name}}" status changed. New status: Pending registration.',
      [EApproveStatus.NOT_SENT]: 'Template "{{name}}" status changed. New status: Draft.',
      [EApproveStatus.ARCHIVED]: 'Template "{{name}}" status changed. New status: Archived.',
    },
    [EWebNotificationType.MessageMatcherCategoryChanged]: `The category of WhatsApp template "{{name}}" was changed by WhatsApp. New category: "{{newCategory}}".`,
    [EWebNotificationType.InvoicePaid]: 'Payment successful.',
    [EWebNotificationType.PaykeeperPayment]: {
      [EPayKeeperNotificationStatus.PAYMENT_FAIL]: 'Your payment from {{date}} failed.',
      [EPayKeeperNotificationStatus.PAYMENT_SUCCESS]:
        'Your payment of {{sum}} has been successfully enrolled on {{date}}.',
      [EPayKeeperNotificationStatus.REFUND_SUCCESS]:
        'Refund of a card payment from {{date}} {{login}} has been completed.',
      [EPayKeeperNotificationStatus.RECURRENT_PAYMENT_SUCCESS]: 'Auto payment has been credited.',
      [EPayKeeperNotificationStatus.RECURRENT_PAYMENT_FAIL]:
        'Failed to debit auto payment from the card.',
      [EPayKeeperNotificationStatus.RECURRENT_CARD_BINDING_CREATED]: 'Auto payment set up',
    },
    [EWebNotificationType.ChannelProfilePartnerProfileCreated]:
      'Select the channel pricing for the WhatsApp account "{{name}}" to complete the registration.',
    [EWebNotificationType.ChannelProfileQualityScoreChanged]:
      'WhatsApp Business API {{name}}: quality changed. New quality: {{qualityScore}}.',
    [EWebNotificationType.ChannelProfileMessagingLimitChanged]:
      'WhatsApp Business API {{name}}: limit changed. New limit: {{messagingLimit}}.',
    [EWebNotificationType.ChannelProfileQualityStatusChanged]:
      'WhatsApp account {{name}} status changed. New status: {{qualityStatus}}.',
    [EWebNotificationType.ChannelProfileWABAViolation]:
      'WhatsApp Business account {{wabaId}} is violating the WhatsApp Business Terms of Service. The reason is {{violationType}}. The following channels may be restricted or disabled: {{channels}}. We recommend that you <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABARestriction]:
      'WhatsApp Business account {{wabaId}} has been restricted due to activity that violates the WhatsApp Business Terms of Service. The following channels are restricted until {{expirationDate}} and can only receive incoming messages: {{channels}}. To submit an appeal, <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABADisable]:
      'WhatsApp Business account {{wabaId}} has been disabled due to activity that violates the WhatsApp Business Terms of Service. The following channels have stopped working: {{channels}}. You cannot register new channels with this WhatsApp Business account. To submit an appeal, <0>follow the recommendations</0>.',
    [EWebNotificationType.ChannelProfileWABAReinstate]:
      'WhatsApp Business account {{wabaId}} has been restored. The following channels become active again: {{channels}}.',
    [EWebNotificationType.ChannelProfileWABAMarketingMessagesApiTermsSigned]: {
      title_one: 'You have successfully accepted the MM API Terms of Use for channel {{channels}}.',
      title_other:
        'You have successfully accepted the MM API Terms of Use for channels {{channels}}.',
    },
    [EWebNotificationType.StripeCheckout]: {
      [EAutopaymentError.GENERIC_DECLINE]:
        'The auto payment failed on {{date}}. For more information, contact technical support <0>{{email}}</0>.',
      [EAutopaymentError.AUTHENTICATION_REQUIRED]:
        'The auto payment failed on {{date}}. Your bank has requested payment confirmation.',
      [EAutopaymentError.CARD_DECLINE]: 'Failed to make an auto payment with the linked card.',
      [EAutopaymentError.INSUFFICIENT_FUNDS]: 'The charge failed on {{date}}. Insufficient funds.',
      [EAutopaymentNotificationStatus.AUTO_REPLENISHMENT_ENABLED]: 'Auto payment activated.',
      [EAutopaymentNotificationStatus.AUTO_REPLENISHMENT_DISABLED]: 'Auto payment deactivated.',
      [EAutopaymentNotificationStatus.PAYMENT_SUCCEEDED]:
        'Auto payment activated. To receive a payment receipt, follow the link to the <0>Stripe payment system website</0>.',
    },
    [EWebNotificationType.MessageReportSuccess]: 'The report {{name}} has been generated.',
    [EWebNotificationType.MessageReportFailed]: '{{name}} report generation has been cancelled.',
    [EWebNotificationType.FlowMessageReportSuccess]: 'The report {{name}} has been generated.',
    [EWebNotificationType.FlowMessageReportFailed]:
      '{{name}} report generation has been cancelled.',

    [EWebNotificationType.ChannelProfileMaxBotRegistration]:
      'Channel "{{name}}" sent for registration.',
    [EWebNotificationType.ChannelProfileMaxBotSubjectCreated]: 'Channel "{{name}}" registered.',
    [EWebNotificationType.ChannelProfileMaxConnected]: 'Channel "{{name}}" connected.',
    [EWebNotificationType.ChannelProfileMaxDisconnected]: 'Channel "{{name}}" disconnected.',
    [EWebNotificationType.ChannelProfileTelegramConnected]: 'Channel "{{name}}" connected.',
    [EWebNotificationType.ChannelProfileTelegramDisconnected]: 'Channel "{{name}}" disconnected.',
  },
  specialOffers: {
    connect: 'Connect',
    offer: {
      [ESpecialOffer.SMS]: {
        title:
          'SMS broadcasts are a classic and cost-effective way for businesses to communicate with customers!',
      },
      [ESpecialOffer.FLOW]: {
        title:
          'A WhatsApp chatbot builder for conversations and broadcasts. Free up your staff by creating interactive broadcasts.',
      },
    },
    mail: {
      [ESpecialOffer.SMS]: {
        subject: 'SMS channel capabilities request {{login}}, {{companyName}}',
        body: 'Hi,\r\nI would like to get more information and explore the capabilities of the SMS channel.',
      },
      [ESpecialOffer.FLOW]: {
        subject: 'Flows features and benefits request {{login}}, {{companyName}}',
        body: 'Hi,\r\nI would like to get more information and explore the capabilities of the Flows.',
      },
    },
  },
};
